var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsOptional } from 'class-validator';
/**
 * Body for `POST /appointments/:id/participants/:patientId/absage` (TM-9737): the office
 * records one patient's Absage. In a group the appointment stands for the others; was it
 * the last active participation, the whole appointment is cancelled.
 */
export class RecordAbsageDto {
    /**
     * When the Absage reached the practice; absent ⇒ now. Neither in the future nor before
     * the appointment was booked.
     */
    receivedAt;
}
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", String)
], RecordAbsageDto.prototype, "receivedAt", void 0);
//# sourceMappingURL=record-absage.dto.js.map